<ng-container *transloco="let t">
  @switch (state.status) {
    @case (ActionStatus.IN_PROGRESS) {
      <pxc-status
        data-testid="status-loading"
        [description]="t('Le télésuivi est en cours de création.')"
        [state]="Status.LOADING"
        [title]="t('Création en cours')">
        <div class="mt-2 flex w-full justify-end gap-2">
          <button appearance="outline" tuiButton type="button" (click)="closeModal()">
            {{ t('Fermer') }}
          </button>
        </div>
      </pxc-status>
    }
    @case (ActionStatus.SUCCESS) {
      <pxc-status
        data-testid="status-success"
        [description]="t('Le télésuivi a été créé avec succès.')"
        [state]="Status.SUCCESS"
        [title]="t('Succès')">
        <div class="mt-2 flex w-full justify-end gap-2">
          <button
            appearance="secondary"
            data-testid="send-tutorial"
            iconStart="@tui.mail"
            tuiButton
            type="button"
            (click)="sendTutorial()">
            {{ t('Envoyer le tutoriel') }}
          </button>
          <button data-testid="close-modal" tuiButton type="button" (click)="closeModal()">
            {{ t('Fermer') }}
          </button>
        </div>
      </pxc-status>
    }
    @case (ActionStatus.ERROR) {
      <pxc-status data-testid="status-fail" [description]="state.message" [state]="Status.ERROR" [title]="t('Échec')">
        <div class="mt-2 flex w-full justify-end gap-2">
          <button data-testid="close-modal" tuiButton type="button" (click)="closeModal()">
            {{ t('Fermer') }}
          </button>
        </div>
      </pxc-status>
    }
  }
</ng-container>
